<template>
  <div class="main">
    <el-dialog
      :title="openData.title"
      :visible.sync="openData.state"
      width="800px"
      @close="dialogClose"
    >
      <div class="btnGroup">
        <el-button
          v-if="!openData.older"
          :type="nums == 0 ? 'primary' : 'info'"
          @click="step(0)"
        >基础信息</el-button><span class="qubtn_span">&nbsp;&nbsp;———&nbsp;&nbsp;</span>
        <el-button
        v-if="!openData.older"
          :type="nums == 1 ? 'primary' : 'info'"
          @click="step(1)"
        >工单信息</el-button><span class="qubtn_span">&nbsp;&nbsp;———&nbsp;&nbsp;</span>
        <el-button
          :type="nums == 2 ? 'primary' : 'info'"
          @click="step(2)"
        >回访信息</el-button><span class="qubtn_span"></span>
      </div>
      <visit-order
        :openData="openData"
        v-show="nums == 1 && !older"
        :datas.sync="gdData"
        ref="gdInfo"
      ></visit-order>
      <visit-person
        :openData="openData"
        v-show="nums == 0 && !older"
      ></visit-person>
      <div
        class="visitMain"
        v-show="nums == 2"
      >
        <div class="visitTitle">
          <p class="name">姓名：{{openData.data.customerName}}</p>
          <p>电话：{{openData.data.customerPhone}}</p>
          <span
            class="iconfont icon-bodadianhua"
            style="font-size: 20px;position: relative;top: -4px;cursor: pointer;margin-left: 12px; "
          ></span>
        </div>

        <el-form
          :model="hfData"
          label-width="100px"
          label-position="left"
        >
          <el-form-item label="问题模板:">
            <el-select
              v-model="hfData.id"
              placeholder="请选择问题"
              style="width:100%"
              @change="setQuestionId"
              value-key="id"
            >
              <el-option
                :label="item.type"
                :value="item.id"
                v-for="item in pList"
                :key="item.id+''"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            :label="'问题 '+(index+1)+'：'+item.problems"
            v-for="(item,index) in hfData.questionList"
            label-width="280px"
          >
            <el-input
              v-model="item.reasons"
              type="textarea"
              style="width:100%"
              placeholder="请输入你的回答"
            ></el-input>
          </el-form-item>
        </el-form>

      </div>
      <div class="footer">
        <el-button
          type="primary"
          @click="save"
          v-if="openData.title!=='查看'"
        >{{nextText}}</el-button>
        <el-button @click="dialogClose">{{openData.title=='查看'?'关闭':'取消'}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getQuestionList,
  postDataOfInfoBack1,
  postDataOfInfoBack2,
} from "../api/index"
import visitOrder from "./visitOrder"
import visitPerson from "./visitPerson"
export default {
  props: ["openData","older"],
  data() {
    return {
      questionId: "",
      hfData: { id: "" },
      gdData: {},
      nextText: "下一步",
      nums: 0,
      pList: [],
      chooseList: [{ que: "", choose: "", content: "" }],
    }
  },
  components: { visitOrder, visitPerson },
  created() {
    this.nums = this.openData.nums
    let communityId = this.openData.commId
    let { evaluationContentId, evaluationContentQuestions } = this.openData.data

    if (
      evaluationContentId &&
      evaluationContentQuestions &&
      evaluationContentQuestions.length
    ) {
      this.hfData.id = evaluationContentId
      this.hfData.questionList = evaluationContentQuestions
    }

    getQuestionList({ communityId, pageSize: 10, pageNo: 1 }).then((res) => {
      let { content } = res
      if (content) {
        let { list } = content
        this.pList = list
      }
    })
  },

  methods: {
    setQuestionId(v) {
      let index = this.pList.findIndex((item) => item.id == v)
      this.hfData.id = v
      this.$set(this.hfData, "questionList", this.pList[index].problemList)
    },
    // 步骤设置
    step(num) {
      this.nums = num
    },
    submitThisData() {
      let flag = false
      if (this.gdData && Object.values(this.gdData).length) {
        let { annex, deliveryEndTime, id } = this.gdData
        postDataOfInfoBack1({ id, annex, deliveryEndTime }).then((res) => {
          let { code } = res
          if (code == 200) {
            flag = true
          }
        })
      }

      !this.gdData && (flag = false)

      if (this.hfData.id) {
        postDataOfInfoBack2({
          id: this.hfData.id,
          orderId: this.openData.data.id,
          problemList: this.hfData.questionList,
        }).then((res) => {
          this.$message({
            type: "success",
            message: "添加回访记录成功！",
          })
          this.dialogClose()
        })
      }
    }, //提交函数
    // 保存信息
    save() {
      switch (this.nums) {
        case 0:
          this.step(1)
          break
        case 1:
          this.$refs["gdInfo"].checkData() && this.step(2)
          break
        case 2:
          this.openData.title == "查看"
            ? this.dialogClose()
            : this.submitThisData()
          break
      }
      //this.$refs["gdInfo"].checkData()

      //this.$emit("canclePerson", true)
    },
    // 关闭人员信息
    dialogClose() {
      this.gdData = {}
      this.$parent.getList()
      this.$emit("canclePerson", false)
    },
  },
  watch: {
    nums(n, o) {
      switch (n) {
        case 1:
          this.nextText = "下一步"
          break
        case 2:
          this.nextText = "提交"
          break
      }
    },
    // gdData(n, o) {
    //   //
    // },
  },
}
</script>
<style lang="less" scoped>
.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}

.mt25 {
  margin-top: 25px;
}
.btnGroup {
  margin-bottom: 30px;
  display: flex;
  justify-content: center;
  .qubtn {
    cursor: not-allowed;
    background-color: #ccc;
    color: #fff;
  }
  .qubtn :hover {
    cursor: not-allowed;
    background-color: #ccc;
    color: #fff;
  }
  .qubtn_span {
    color: #409eff;
    margin-top: 10px;
  }
}
.visitMain {
  padding: 0 40px;
  .visitTitle {
    display: flex;
    .name {
      flex: 1;
    }
  }
}
.itemBox {
  display: flex;
  margin-bottom: 24px;
  .name {
    width: 120px;
  }
  .itemContent {
    flex: 1;
    width: 0;
  }
}
.chooseBox {
  margin-top: 24px;
}
</style>